<!-- ═══ Loading ═══════════════════════════════════════════════════════════════ -->
@if (loading) {
  <div class="shell-init">
    <div class="ds-spinner"></div>
  </div>
}

<!-- ═══════════════════════════════════════════════════════════════════════════
VIP SHELL — full-screen fixed overlay, new ds- design
Only rendered when user has an active subscription
════════════════════════════════════════════════════════════════════════════ -->
@if (!loading && isVip) {
  <div class="ds-shell" dir="rtl">
    <!-- Topbar -->
    <header class="ds-topbar">
      <div class="ds-topbar__start">
        <button type="button" class="ds-topbar__menu" (click)="menuOpen = !menuOpen"
          [attr.aria-expanded]="menuOpen" aria-label="תפריט אזור אישי">
          <i class="mdi" [class.mdi-menu]="!menuOpen" [class.mdi-close]="menuOpen"></i>
        </button>
        <div class="ds-topbar__brand" [routerLink]="['/']">sale<span>4</span>all</div>
        <div class="ds-topbar__sep"></div>
        <div class="ds-topbar__crumb">
          <span class="ds-topbar__crumb-parent" [routerLink]="['/personal/my-ads']">אזור אישי</span>
          <i class="mdi mdi-chevron-left ds-topbar__chevron"></i>
          <span class="ds-topbar__crumb-current">{{ crumbLabel() }}</span>
        </div>
      </div>
      <div class="ds-topbar__end">
        <span class="ds-tier-pill" [class.ds-tier-pill--vip]="isVip" [class.ds-tier-pill--standard]="!isVip">
          <i class="fas" [class.fa-crown]="isVip" [class.fa-user]="!isVip"></i>
          {{ isVip ? 'מנוי VIP' : 'חשבון רגיל' }}
        </span>
        <a [routerLink]="['/personal/vip-dashboard']" class="ds-btn ds-btn--vip">
          <i class="mdi mdi-view-dashboard"></i> <span class="ds-btn__text">לוח הבקרה</span>
        </a>
        <a [routerLink]="['/publish']" class="ds-btn ds-btn--cta">
          <i class="mdi mdi-plus"></i> <span class="ds-btn__text">פרסום מודעה חדשה</span>
        </a>
      </div>
    </header>
    <!-- Layout -->
    <div class="ds-layout">
      <!-- Sidebar -->
      @if (menuOpen) {
        <div class="ds-backdrop" (click)="menuOpen = false"></div>
      }
      <aside class="ds-sidebar" [class.ds-sidebar--open]="menuOpen">
        <div class="ds-sidebar__profile">
          <div class="ds-avatar-wrap">
            <app-images-box [selectClass]="'personal-area'" [avatarSize]="64" [editable]="false" [imageSelected]="userInfo.avatar"></app-images-box>
          </div>
          <div class="ds-sidebar__profile-info">
            <p class="ds-sidebar__name">{{ userInfo.first_name }} {{ userInfo.last_name }}</p>
            <p class="ds-sidebar__phone">{{ userInfo.mainPhone }}</p>
          </div>
        </div>
        <div class="ds-sidebar__sub">
          <div class="ds-sub-card" [class.ds-sub-card--vip]="isVip">
            <i class="fas ds-sub-card__icon" [class.fa-crown]="isVip" [class.fa-user-circle]="!isVip"></i>
            <div>
              <div class="ds-sub-card__label">החבילה שלך</div>
              <div class="ds-sub-card__tier">{{ isVip ? 'מנוי VIP' : 'חשבון רגיל' }}</div>
            </div>
          </div>
        </div>
        <nav class="ds-nav">
          <p class="ds-nav__section-label">ניהול</p>
          <a class="ds-nav__item" [routerLink]="['/personal/vip-dashboard']">
            <i class="mdi mdi-view-dashboard"></i>
            <span>לוח בקרה</span>
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/my-ads']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-bulletin-board"></i>
            <span>המודעות שלי</span>
            @if (totalAds > 0) {
              <span class="ds-nav__badge">{{ totalAds }}</span>
            }
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/inquiries']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-forum"></i>
            <span>פניות</span>
            @if ((inquiries.unread$ | async); as n) {
              <span class="ds-nav__badge">{{ n }}</span>
            }
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/feed']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-rss"></i>
            <span>עוקב אחרי</span>
          </a>
          <a class="ds-nav__item" [routerLink]="['/publish']">
            <i class="mdi mdi-plus-circle-outline"></i>
            <span>פרסם מודעה</span>
          </a>
          <p class="ds-nav__section-label" style="margin-top:12px">חשבון</p>
          <a class="ds-nav__item" [routerLink]="['/personal/user-info']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-account-outline"></i>
            <span>פרופיל</span>
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/followers']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-account-multiple-outline"></i>
            <span>ניהול עוקבים</span>
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/store']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-store"></i>
            <span>החנות שלי</span>
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/wishlist']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-heart-outline"></i>
            <span>רשימת משאלות</span>
          </a>
          <a class="ds-nav__item" [routerLink]="['/personal/benefits']" routerLinkActive="ds-nav__item--active">
            <i class="mdi mdi-ticket-percent"></i>
            <span>ההטבות שלי</span>
          </a>
          <p class="ds-nav__section-label" style="margin-top:12px">מנוי</p>
          <a class="ds-nav__item" [routerLink]="['/personal/vip-subscription']" routerLinkActive="ds-nav__item--active">
            <i class="fas fa-crown"></i>
            <span>חבילות VIP</span>
          </a>
        </nav>
        <button type="button" class="ds-sidebar__logout" (click)="logout()">
          <i class="mdi mdi-logout-variant" aria-hidden="true"></i>
          <span>התנתק מהחשבון</span>
        </button>
      </aside>
      <!-- Main -->
      <main class="ds-main">
        <app-business-status-banner></app-business-status-banner>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
}

<!-- ═══════════════════════════════════════════════════════════════════════════
NON-VIP SHELL — classic Bootstrap account-page skin
Rendered inside the normal site layout (header + footer stay visible)
════════════════════════════════════════════════════════════════════════════ -->
@if (!loading && !isVip) {
  <section class="account-page section-padding" dir="rtl">
    <div class="container-fluid">
      <div class="row no-gutters">
        <!-- Classic sidebar -->
        @if (menuOpen) {
          <div class="account-backdrop" (click)="menuOpen = false"></div>
        }
        <div class="col-md-3 col-lg-3 account-drawer" [class.account-drawer--open]="menuOpen">
          <div class="card account-left">
            <div class="user-profile-header">
              <div class="col">
                <app-images-box [selectClass]="'personal-area'" [avatarSize]="86" [editable]="false" [imageSelected]="userInfo.avatar"></app-images-box>
              </div>
              <h5 class="mb-1"><strong>שלום</strong> {{ userInfo.first_name }}</h5>
              <p>{{ userInfo.mainPhone }}</p>
            </div>
            <div class="list-group">
              <a [routerLink]="['/personal/user-info']" routerLinkActive="active"
                class="list-group-item list-group-item-action">
                <i aria-hidden="true" class="mdi mdi-account-outline"></i> פרופיל
              </a>
              <a [routerLink]="['/personal/my-ads']" routerLinkActive="active"
                class="list-group-item list-group-item-action">
                <i aria-hidden="true" class="mdi mdi-bulletin-board"></i> המודעות שלי
              </a>
              <!-- SCRUM-116 follow-up: a store is VIP-only now, so the
                   classic (non-VIP) sidebar no longer links to it — the
                   upgrade-nudge below is where a regular user gets to it. -->
              <a [routerLink]="['/personal/inquiries']" routerLinkActive="active"
                class="list-group-item list-group-item-action">
                <i aria-hidden="true" class="mdi mdi-forum"></i> פניות
                @if ((inquiries.unread$ | async); as n) {
                  <span class="badge badge-success" style="margin-inline-start:6px">{{ n }}</span>
                }
              </a>
              <a [routerLink]="['/personal/wishlist']" routerLinkActive="active"
                class="list-group-item list-group-item-action">
                <i aria-hidden="true" class="mdi mdi-heart-outline"></i> רשימת משאלות
              </a>
              <a [routerLink]="['/personal/benefits']" routerLinkActive="active"
                class="list-group-item list-group-item-action">
                <i aria-hidden="true" class="mdi mdi-ticket-percent"></i> ההטבות שלי
              </a>
              <a [routerLink]="['/publish']" class="list-group-item list-group-item-action">
                <i aria-hidden="true" class="mdi mdi-plus-circle-outline"></i> פרסם מודעה
              </a>
              <a href="#" class="list-group-item list-group-item-action" (click)="logout()">
                <i aria-hidden="true" class="mdi mdi-lock"></i> התנתק
              </a>
            </div>
            <!-- Upgrade nudge -->
            <div class="upgrade-nudge">
              <i class="fas fa-crown"></i>
              <span>שדרג למנוי VIP</span>
              <a [routerLink]="['/personal/vip-subscription']" class="upgrade-link">בחר חבילה</a>
            </div>
          </div>
        </div>
        <!-- Content area -->
        <div class="col-md-9 col-lg-9">
          <button type="button" class="account-menu-toggle" (click)="menuOpen = true"
            [attr.aria-expanded]="menuOpen" aria-label="תפריט אזור אישי">
            <i class="mdi mdi-menu" aria-hidden="true"></i>
            <span>תפריט אזור אישי</span>
          </button>
          <div class="card card-body account-right">
            <app-business-status-banner></app-business-status-banner>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </section>
}
